/**
 * 게시판 목록 조회를 위한 React Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { boardService } from '../../features/admin/services/boardService';
import { BoardListItem } from '../types/board.types';

interface UseBoardOptions {
  page?: number;
  limit?: number;
  enabled?: boolean;
}

interface PaginationResponse<T> {
  data: T[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

/**
 * 게시판 목록을 조회하는 Hook
 * @param boardType - 게시판 타입 (news, gallery, bulletin, sunday-school 등)
 * @param options - 페이지, 제한 개수, 활성화 여부 옵션
 */
export const useBoard = (
  boardType: string,
  options: UseBoardOptions = {}
) => {
  const { page = 1, limit = 9, enabled = true } = options;

  return useQuery<PaginationResponse<BoardListItem>>({
    queryKey: ['board', boardType, page, limit],
    queryFn: async () => {
      const response = await boardService.getPosts(boardType, page, limit);
      return response;
    },
    // staleTime: 데이터를 신선하게 유지하는 시간 (이 시간 동안 API 재호출 안 함)
    // gcTime: 컴포넌트 unmount 후에도 캐시를 메모리에 유지하는 시간
    //         (뒤로가기 등으로 재방문 시 즉시 캐시 데이터 표시)
    enabled, // 조건부 쿼리 실행
  });
};